export const CONDITION_INTERVAL_VALUE_TYPE = 'valueInterval';
